import Big from 'big.js';

export {};

export interface OrderProduct {
  id: number;
  userId: number;
  productId: number;
  productSn: string;
  quantity: number;
  price: string;
  productPic: string;
  productName: string;
  createDate: string;
  modifyDate: string | null;
  deleteStatus: number;
  valid: number;
  onLine: number;
  relates: null;
  models: ProductModel[];
  pmsFiles: PmsFile[];
  unit?: string;
  prices?:number[]
}

interface ProductModel {
  id: number;
  productId: number;
  models: string;
  price: string;
  originalPrice: string | null;
  type: number;
  productStock: number;
  salesVolume: number;
  unit: string;
  version: number;
  packSize: number;
  sendDate: string | null;
}

interface PmsFile {
  id: number;
  name: string;
  url: string;
  ftpPath: string | null;
  createTime: string;
}

/**
 * 计算单个价格
 * models
 *     type 为1  对应选中的规格信息，里面有对应的单价
 *     type 为3  对应选中的延保信息，里面有对应的延保收费单价
 *     ( 规格对应单价 + 服务单价 ) * 个数
 *  */
export const computePrice = (product: OrderProduct) => {
  // 规格 - 有且只有一个
  const specs1 = product.models.find((v) => v.type === 1) as ProductModel;
  const specs3 = product.models.find((v) => v.type === 3);
  // 使用 Big.js 处理单价和延保价格
  const price = new Big(specs1.price); // 规格单价
  const servicePrice = specs3 ? new Big(specs3.price) : new Big(0); // 延保单价，如果没有则为 0
  const productQuantity = new Big(product.quantity); // 商品数量

  // 计算总价：(规格单价 + 延保单价) * 数量
  const totalPrice = price.plus(servicePrice).times(productQuantity);

  // 返回结果（转换为字符串，避免精度丢失）
  return totalPrice.toString();
};

/** 计算所有价格 */
export const getTotalPrice = (selectedGoods: OrderProduct[]): string => {
  // 初始化总价为 0
  let totalPrice = new Big(0);

  // 遍历 selectedGoods 数组，计算每个商品的总价并累加
  selectedGoods.forEach((product) => {
    const productTotalPrice = new Big(computePrice(product));
    totalPrice = totalPrice.plus(productTotalPrice);
  });
  const totalPrices = Number(totalPrice).toFixed(2);//补位.00
  // 返回最终的总价（转换为字符串，避免精度丢失）
  return totalPrices.toString();
};

export const getFinalPrice = (totalAmount:string,couponAmount:string) => { 
  const totalPrice = parseFloat(totalAmount);
  const couponPrice = parseFloat(couponAmount);
  console.log(totalAmount,couponAmount,totalPrice -couponPrice,'ddd')
  return (totalPrice -couponPrice).toFixed(2).toString();
}